// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"CustomTooltip_Tooltip__3olwT"};